module.exports = __webpack_public_path__ + "img/welcomes-all.d64f48b5.png";